// Single source of truth for every way a visitor can reach Danillo.
// Change a handle here and every page (and every Time Machine era) follows.

export const WHATSAPP_NUMBER = '5511993332805';
export const WHATSAPP_DISPLAY = '+55 11 99333-2805';
export const EMAIL = 'danillog821@gmail.com';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/danillogomes';
export const GITHUB_URL = 'https://github.com/danillog';
export const EMPLOYER_URL = 'https://www.conceptu.ind.br/';
// Client work goes to the studio so the two sites don't compete. Set it to
// 'https://gomescode.com' once that site is live and the home page shows the
// line pointing there; until then no link, so nobody lands on a dead page.
export const GOMES_CODE_URL = null;

export const mailtoUrl = (subject) => `mailto:${EMAIL}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`;

const WHATSAPP_GREETING = {
  pt: 'Olá, Danillo! Vim pelo seu portfólio e gostaria de conversar sobre um projeto.',
  en: "Hi Danillo! I found your portfolio and I'd like to talk about a project.",
};

const WHATSAPP_ABOUT_PROJECT = {
  pt: (title) => `Olá, Danillo! Vi o projeto "${title}" no seu portfólio e quero algo nessa linha.`,
  en: (title) => `Hi Danillo! I saw "${title}" in your portfolio and I'm looking for something along those lines.`,
};

const langKey = (lang) => (lang && lang.startsWith('pt') ? 'pt' : 'en');

export const whatsappUrl = (lang, projectTitle) => {
  const key = langKey(lang);
  const text = projectTitle ? WHATSAPP_ABOUT_PROJECT[key](projectTitle) : WHATSAPP_GREETING[key];
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
};
